import { LocaleProvider } from 'antd'
import trTR from 'antd/es/locale-provider/tr_TR'
import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Route } from 'react-router-dom'
import configureStore from './configureStore'
// app styles
import './global.scss'
import sagas from './redux/sagas'
import { ApplicationState } from './redux/store'
import Router from './router'

const history = createBrowserHistory()
const initialState = (window as any).initialReduxState as ApplicationState
const { store, sagaMiddleware } = configureStore(history, initialState)

sagaMiddleware.run(sagas)

//React Intl missing messalarını dev ortamında kaldırdım.
if (process.env.NODE_ENV !== 'production') {
  const originalConsoleError = console.error
  if (console.error === originalConsoleError) {
    console.error = (...args) => {
      return
      originalConsoleError.call(console, ...args)
    }
  }
}

var routes = <Route path="*" render={props => <Router {...props} />} />

ReactDOM.render(
  <Provider store={store}>
    <LocaleProvider locale={trTR}>
      <ConnectedRouter history={history} children={routes} />
    </LocaleProvider>
  </Provider>,
  document.getElementById('root'),
)

export { store, history }
